var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 1.26929L14.4678 1.26929L9.55445 6.88495L15.3346 14.5266H10.8088L7.26399 9.89198L3.20793 14.5266H0.95759L6.21293 8.52002L0.667969 1.26929L5.30871 1.26929L8.5129 5.50551L12.2188 1.26929ZM11.4295 13.1805H12.6757L4.63157 2.54471H3.29428L11.4295 13.1805Z",
    fill: "#131316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.6e6de23137a0179f4cad532c85e9d054.svg";
export { ForwardRef as ReactComponent };